import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { FileItemInfo } from '../../types/FileItemInfo';
import { requestAllFiles, requestUploadFile } from '../myFile/myFile';

export const useGetAllFiles = () => {
    return useQuery<FileItemInfo[]>({
        queryKey: ['myFile'],
        queryFn: async ({ signal }) => {
            return (await requestAllFiles(signal)).data;
        },
    });
};

export const useUploadFile = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (data: FormData) => (await requestUploadFile(data)).data,
        onSuccess: async => {
            queryClient.invalidateQueries({ queryKey: ['myFile'] });
        },
    });
};
